export const TRANSLATIONS = {
    EN: {
        UBO_PROCESS: {
            WAIT_FOR_SIGNING: {
                BOOKKEEPER: {
                    TITLE: 'Wait for signing the documents by the shareholders',
                    DESCRIPTION: 'The ubo declaration has been drafted by the notary is ready for signature. An email invitation has been sent to each ubo to digitally sign the power of attorney.',
                },
                CLIENT: {
                    TITLE: 'Signing power of attorney',
                    DESCRIPTION: 'The ubo declaration has been drafted by the notary is ready for signature. An email invitation has been sent to each ubo to digitally sign the power of attorney.',
                },
                NOTARY: {
                    TITLE: 'Wait for signing the documents by the shareholders',
                    DESCRIPTION: 'The ubo declaration has been drafted by the notary is ready for signature. An email invitation has been sent to each ubo to digitally sign the power of attorney.',
                },
                SUPPORT: {
                    TITLE: 'Wait for signing the documents by the shareholders',
                    DESCRIPTION: 'The ubo declaration has been drafted by the notary is ready for signature. An email invitation has been sent to each ubo to digitally sign the power of attorney.',
                },
            },
            WAIT_FOR_IDENTIFICATION: {
                BOOKKEEPER: {
                    TITLE: 'Complete digital identification',
                    DESCRIPTION: 'Each ubo has received an invitation by email for the digital identification. You can easily change a ubo’s email address or phone number as long as the identification has not been completed. The applicant of the procedure can also do this himself.',
                },
                CLIENT: {
                    TITLE: 'Complete digital identification',
                    DESCRIPTION: 'Before the notary can start the incorporation, all ubo(s) must identify themselves digitally. An invitation has been sent to every ubo with a link to start the digital identification. If the mail has not arrived correctly, you can still change the email address. The invitation will be automatically resent.',
                },
                NOTARY: {
                    TITLE: 'Complete digital identification',
                    DESCRIPTION: 'Each ubo has received an invitation by email for the digital identification. You can easily change a ubo’s email address or phone number as long as the identification has not been completed. The applicant of the procedure can also do this himself.',
                },
                SUPPORT: {
                    TITLE: 'Complete digital identification',
                    DESCRIPTION: 'Each ubo has received an invitation by email for the digital identification. You can easily change a ubo’s email address or phone number as long as the identification has not been completed. The applicant of the procedure can also do this himself.',
                },
            },
            WAIT_FOR_PROCESSES: {
                BOOKKEEPER: {
                    TITLE: 'Waiting to complete UBO registration(s)',
                    DESCRIPTION: 'Thank you for completing the request. The notary will process the application. If you have submitted the application for several BVs, you will see the application procedure per BV in the overview.',
                },
                CLIENT: {
                    TITLE: 'Waiting to complete UBO registration(s)',
                    DESCRIPTION: 'Thank you for completing the request. The notary will process the application. If you have submitted the application for several BVs, you will see the application procedure per BV in the overview.',
                },
                NOTARY: {
                    TITLE: 'Waiting to complete UBO registration(s)',
                    DESCRIPTION: 'Thank you for completing the request. The notary will process the application. If you have submitted the application for several BVs, you will see the application procedure per BV in the overview.',
                },
                SUPPORT: {
                    TITLE: 'Waiting to complete UBO registration(s)',
                    DESCRIPTION: 'Thank you for completing the request. The notary will process the application. If you have submitted the application for several BVs, you will see the application procedure per BV in the overview.',
                },
            },
            REVIEW_DOSSIER: {
                BOOKKEEPER: {
                    TITLE: 'Review UBO application',
                    DESCRIPTION: 'The notary has received the application, will check the application and will proceed with the procedure. You will receive a notification by e-mail as soon as the application is submitted to the UBO register.',
                },
                CLIENT: {
                    TITLE: 'Review UBO application',
                    DESCRIPTION: 'The notary has received the application, will check the application and will proceed with the procedure. You will receive a notification by e-mail as soon as the application is submitted to the UBO register.',
                },
                NOTARY: {
                    TITLE: 'Review UBO application',
                    DESCRIPTION: 'The notary has received the application, will check the application and will proceed with the procedure. You will receive a notification by e-mail as soon as the application is submitted to the UBO register.',
                },
                SUPPORT: {
                    TITLE: 'Review UBO application',
                    DESCRIPTION: 'The notary has received the application, will check the application and will proceed with the procedure. You will receive a notification by e-mail as soon as the application is submitted to the UBO register.',
                },
            },
            FINISH_REGISTRATION: {
                BOOKKEEPER: {
                    TITLE: 'Confirm UBO registration',
                    DESCRIPTION: 'The application for UBO registration has been submitted to the UBO register. You will receive a notification by e-mail as soon as the registration is confirmed.',
                },
                CLIENT: {
                    TITLE: 'Confirm UBO registration',
                    DESCRIPTION: 'The application for UBO registration has been submitted to the UBO register. You will receive a notification by e-mail as soon as the registration is confirmed.',
                },
                NOTARY: {
                    TITLE: 'Confirm UBO registration',
                    DESCRIPTION: 'The application for UBO registration has been submitted to the UBO register. You will receive a notification by e-mail as soon as the registration is confirmed.',
                },
                SUPPORT: {
                    TITLE: 'Confirm UBO registration',
                    DESCRIPTION: 'The application for UBO registration has been submitted to the UBO register. You will receive a notification by e-mail as soon as the registration is confirmed.',
                },
            },
            SUCCESSFUL: {
                DIGITAL_SHR: 'to open your Digital Shareholder Register.',
                CLIENT: {
                    TITLE: 'Procedure completed',
                },
                NOTARY: {
                    TITLE: 'Procedure completed',
                    DESCRIPTION: 'The procedure is completed. Many thanks for your excellent service!',
                },
                SUPPORT: {
                    TITLE: 'Procedure completed',
                    DESCRIPTION: 'The procedure is completed. Many thanks for your excellent service!',
                },
                BOOKKEEPER: {
                    TITLE: 'Procedure completed',
                    DESCRIPTION: 'The procedure is completed. Many thanks for your excellent service!',
                },
            },
            REQUEST_DOCUMENTS: {
                SUPPORT: {
                    TITLE: 'Waiting for submission of required documents',
                },
                CLIENT: {
                    TITLE: 'Submit requested documents',
                },
                NOTARY: {
                    TITLE: 'Waiting for submission of required documents',
                },
                BOOKKEEPER: {
                    TITLE: 'Submit requested documents',
                },
            },
        },
    },
    NL: {
        UBO_PROCESS: {
            WAIT_FOR_SIGNING: {
                BOOKKEEPER: {
                    TITLE: 'Wacht op ondertekening door de aandeelhouders',
                    DESCRIPTION: 'De ubo verklaring is opgesteld door de notaris en staat klaar voor ondertekening. Er is een uitnodiging per email naar elke oprichter gestuurd om de volmacht digitaal te ondertekenen.',
                },
                CLIENT: {
                    TITLE: 'Ondertekening volmacht',
                    DESCRIPTION: 'De ubo verklaring is opgesteld door de notaris en staat klaar voor ondertekening. Er is een uitnodiging per email naar elke oprichter gestuurd om de volmacht digitaal te ondertekenen.',
                },
                NOTARY: {
                    TITLE: 'Wacht op ondertekening door de aandeelhouders',
                    DESCRIPTION: 'De ubo verklaring is opgesteld door de notaris en staat klaar voor ondertekening. Er is een uitnodiging per email naar elke oprichter gestuurd om de volmacht digitaal te ondertekenen.',
                },
                SUPPORT: {
                    TITLE: 'Wacht op ondertekening door de aandeelhouders',
                    DESCRIPTION: 'De ubo verklaring is opgesteld door de notaris en staat klaar voor ondertekening. Er is een uitnodiging per email naar elke oprichter gestuurd om de volmacht digitaal te ondertekenen.',
                },
            },
            WAIT_FOR_IDENTIFICATION: {
                BOOKKEEPER: {
                    TITLE: 'Wacht op digitale identificatie van de ubos',
                    DESCRIPTION: 'Elke ubo heeft uitnodiging per email ontvangen voor de digitale identificatie. Je kunt eenvoudig het e-mailadres of telefoonnummer wijzigen van een ubo zolang de identificatie nog niet is voltooid. De aanvrager kan dit zelf ook doen.',
                },
                CLIENT: {
                    TITLE: 'Voltooi digitale identificatie',
                    DESCRIPTION: 'Voordat de notaris de oprichting kan starten dienen alle ubo(s) zich digitaal te identificeren. Er is een uitnodiging per email naar elke ubo gestuurd met een link om de digitale identificatie te starten. Is de mail niet goed aangekomen dan kun je het emailadres nog aanpassen. De uitnodiging wordt automatisch opnieuw verstuurd.',
                },
                NOTARY: {
                    TITLE: 'Wacht op digitale identificatie van de ubos',
                    DESCRIPTION: 'Elke ubo heeft uitnodiging per email ontvangen voor de digitale identificatie. Je kunt eenvoudig het e-mailadres of telefoonnummer wijzigen van een ubo zolang de identificatie nog niet is voltooid. De aanvrager kan dit zelf ook doen.',
                },
                SUPPORT: {
                    TITLE: 'Wacht op digitale identificatie van de ubos',
                    DESCRIPTION: 'Elke ubo heeft uitnodiging per email ontvangen voor de digitale identificatie. Je kunt eenvoudig het e-mailadres of telefoonnummer wijzigen van een ubo zolang de identificatie nog niet is voltooid. De aanvrager kan dit zelf ook doen.',
                },
            },
            WAIT_FOR_PROCESSES: {
                BOOKKEEPER: {
                    TITLE: 'Wacht op voltooien UBO registratie(s)',
                    DESCRIPTION: 'Dank voor het voltooien van de aanvraag. De notaris zal de aanvraag in behandeling nemen. Indien u voor meerdere BV\'s de aanvraag heeft verricht, ziet u in het overzicht de aanvraagprocedure per BV.',
                },
                CLIENT: {
                    TITLE: 'Wacht op voltooien UBO registratie(s)',
                    DESCRIPTION: 'Dank voor het voltooien van de aanvraag. De notaris zal de aanvraag in behandeling nemen. Indien u voor meerdere BV\'s de aanvraag heeft verricht, ziet u in het overzicht de aanvraagprocedure per BV.',
                },
                NOTARY: {
                    TITLE: 'Wacht op voltooien UBO registratie(s)',
                    DESCRIPTION: 'Dank voor het voltooien van de aanvraag. De notaris zal de aanvraag in behandeling nemen. Indien u voor meerdere BV\'s de aanvraag heeft verricht, ziet u in het overzicht de aanvraagprocedure per BV.',
                },
                SUPPORT: {
                    TITLE: 'Wacht op voltooien UBO registratie(s)',
                    DESCRIPTION: 'Dank voor het voltooien van de aanvraag. De notaris zal de aanvraag in behandeling nemen. Indien u voor meerdere BV\'s de aanvraag heeft verricht, ziet u in het overzicht de aanvraagprocedure per BV.',
                },
            },
            REVIEW_DOSSIER: {
                BOOKKEEPER: {
                    TITLE: 'Review UBO aanvraag',
                    DESCRIPTION: 'De notaris heeft de aanvraag ontvangen, controleert de aanvraag en gaat verder met de procedure. U ontvangt per e-mail een notificiatie zodra de aanvraag is ingediend bij het UBO-register.',
                },
                CLIENT: {
                    TITLE: 'Review UBO aanvraag',
                    DESCRIPTION: 'De notaris heeft de aanvraag ontvangen, controleert de aanvraag en gaat verder met de procedure. U ontvangt per e-mail een notificiatie zodra de aanvraag is ingediend bij het UBO-register.',
                },
                NOTARY: {
                    TITLE: 'Review UBO aanvraag',
                    DESCRIPTION: 'De notaris heeft de aanvraag ontvangen, controleert de aanvraag en gaat verder met de procedure. U ontvangt per e-mail een notificiatie zodra de aanvraag is ingediend bij het UBO-register.',
                },
                SUPPORT: {
                    TITLE: 'Review UBO aanvraag',
                    DESCRIPTION: 'The notary has received the application, will check the application and will proceed with the procedure. You will receive a notification by e-mail as soon as the application is submitted to the UBO register.',
                },
            },
            FINISH_REGISTRATION: {
                BOOKKEEPER: {
                    TITLE: 'Bevestig UBO registratie',
                    DESCRIPTION: 'De aanvraag voor UBO registratie is ingediend bij het UBO register. U ontvangt een bericht per e-mail zodra de registratie is bevestigd.',
                },
                CLIENT: {
                    TITLE: 'Bevestig UBO registratie',
                    DESCRIPTION: 'De aanvraag voor UBO registratie is ingediend bij het UBO register. U ontvangt een bericht per e-mail zodra de registratie is bevestigd.',
                },
                NOTARY: {
                    TITLE: 'Bevestig UBO registratie',
                    DESCRIPTION: 'De aanvraag voor UBO registratie is ingediend bij het UBO register. U ontvangt een bericht per e-mail zodra de registratie is bevestigd.',
                },
                SUPPORT: {
                    TITLE: 'Bevestig UBO registratie',
                    DESCRIPTION: 'De aanvraag voor UBO registratie is ingediend bij het UBO register. U ontvangt een bericht per e-mail zodra de registratie is bevestigd.',
                },
            },
            SUCCESSFUL: {
                DIGITAL_SHR: 'om uw digitale aandeelhoudersregister te openen.',
                CLIENT: {
                    TITLE: 'Procedure voltooid',
                },
                NOTARY: {
                    TITLE: 'Procedure voltooid',
                    DESCRIPTION: 'De procedure is voltooid. Hartelijk bedankt voor de uitstekende service!',
                },
                SUPPORT: {
                    TITLE: 'Procedure voltooid',
                    DESCRIPTION: 'De procedure is voltooid. Hartelijk bedankt voor de uitstekende service!',
                },
                BOOKKEEPER: {
                    TITLE: 'Procedure voltooid',
                    DESCRIPTION: 'De procedure is voltooid. Hartelijk bedankt voor de uitstekende service!',
                },
            },
            REQUEST_DOCUMENTS: {
                SUPPORT: {
                    TITLE: 'Wachten op indiening van vereiste documenten',
                },
                CLIENT: {
                    TITLE: 'Dien gevraagde documenten in',
                },
                NOTARY: {
                    TITLE: 'Wachten op indiening van vereiste documenten',
                },
                BOOKKEEPER: {
                    TITLE: 'Dien gevraagde documenten in',
                },
            },
        },
    },
};
